<template>
  <div class="the-navbar__user-meta flex items-center" v-if="user !== null">
    <!--   <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ user.name }}</p>
      <small>Available</small>
    </div> -->

    <referral-link-popup ref="referalLinkPopup" />

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img">
        <img key="onlineImg" :src="userIcon" alt="user-img" width="32" class="cursor-pointer" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul>
          <li disabled class="flex py-2 px-4">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2"
              ><b>{{ user.firstName }}</b></span
            >
          </li>

          <vs-divider class="m-1" v-if="hasPermission('vp.crm.referrallink.show')" />

          <li
            v-if="hasPermission('vp.crm.referrallink.show')"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="showPersonalLink"
          >
            <feather-icon icon="LinkIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Consent&nbsp;link</span>
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
//import { msalMixin } from 'vue-msal';
import ReferralLinkPopup from "./ReferralLinkPopup.vue";
import userIcon from "@/assets/images/user-icon.png";

export default {
  data() {
    return {
      userIcon,
    };
  },
  components: {
    ReferralLinkPopup,
  },
  computed: {
    user() {
      let user = null;
      if (this.$AuthService.isAuthenticated()) {
        // Note that the dollar sign ($) is missing from this.msal
        user = {
          ...this.$AuthService.getUser(),
          profile: {},
        };
      }

      return user;
    },
  },
  methods: {
    logout() {
      this.$AuthService.logout();
    },
    showPersonalLink() {
      this.$refs.referalLinkPopup.show();
    },
  },
};
</script>
